module.exports = __webpack_public_path__ + "img/soutaa.aea4338c.jpg";